import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentMedical } from '@modules/types/graphql';

export type Entity = Partial<StudentMedical> | null;

type stringBoolean = '0' | '1';

@DecribeEntity('StudentMedicalEntity')
class StudentMedicalEntity extends BaseEntity {
    diets: string;
    proneToColdBool: stringBoolean;
    proneToCold: string;
    fractures: string;
    headInjuries: string;
    allergicDiseases: string;
    allergyMedications: string;
    chronicDiseases: string;
    medications: string;
    heatTransfer: string;
    insectBites: string;
    healthSpecials: string;
    fatigueBool: stringBoolean;
    fatigue: string;
    motionSicknessBool: stringBoolean;
    motionSickness: string;
    wearingGlassesBool: stringBoolean;
    wearingGlasses: string;
    fearDarkBool: stringBoolean;
    fearDark: string;
    otherSpecials: string;

    constructor(entity: Entity) {
        super(entity);

        this.diets = entity?.diets ?? '';
        this.proneToColdBool = (entity?.proneToColdBool ?? '0') as stringBoolean;
        this.proneToCold = entity?.proneToCold ?? '';
        this.fractures = entity?.fractures ?? '';
        this.headInjuries = entity?.headInjuries ?? '';
        this.allergicDiseases = entity?.allergicDiseases ?? '';
        this.allergyMedications = entity?.allergyMedications ?? '';
        this.chronicDiseases = entity?.chronicDiseases ?? '';
        this.medications = entity?.medications ?? '';
        this.heatTransfer = entity?.heatTransfer ?? '';
        this.insectBites = entity?.insectBites ?? '';
        this.healthSpecials = entity?.healthSpecials ?? '';
        this.fatigueBool = (entity?.fatigueBool ?? '0') as stringBoolean;
        this.fatigue = entity?.fatigue ?? '';
        this.motionSicknessBool = (entity?.motionSicknessBool ?? '0') as stringBoolean;
        this.motionSickness = entity?.motionSickness ?? '';
        this.wearingGlassesBool = (entity?.wearingGlassesBool ?? '0') as stringBoolean;
        this.wearingGlasses = entity?.wearingGlasses ?? '';
        this.fearDarkBool = (entity?.fearDarkBool ?? '0') as stringBoolean;
        this.fearDark = entity?.fearDark ?? '';
        this.otherSpecials = entity?.otherSpecials ?? '';
    }
}

export { StudentMedicalEntity };
